import { createI18n } from 'vue-i18n'
import axios from 'axios'

import messages from './messages'
import dateTimeFormats from './dateTimeFormats'

export const i18n = createI18n({
  locale: localStorage.getItem('lang') || 'en', // set locale
  fallbackLocale: 'en',
  messages, // set locale messages
  dateTimeFormats,
  globalInjection: true,
})

export function setI18nLanguage(lang: string) {
  i18n.global.locale = lang
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html')?.setAttribute('lang', lang)
  localStorage.setItem('lang', lang)
  return lang
}

export const loadLanguageAsync = (lang: string) => {
  if (i18n.global.locale !== lang) {
    return Promise.resolve(setI18nLanguage(lang))
  }
  return Promise.resolve(lang)
}
